import * as React from 'react';
import './PageNotFound.css';

class PageNotFound extends React.Component {
    render() {
        return <p id="page-not-found"> Page Not Accessible</p>;
    }
}

export default PageNotFound;
